import {
  plecoDefaultToneColorsDark,
  plecoDefaultToneColorsLight,
} from "@-/com.npmjs.pleco-default-tone-colors";

const uppercaseHex = (hex: string) => hex.toUpperCase();

/**
 * Default semantic names and hex values for per-tone coloring in light and dark UI.
 *
 * Hex values come from `pleco-default-tone-colors`. Custom tone colors are disabled for now;
 * everyone defaults to Pleco.
 */
export const DEFAULT_TONE_COLOR_SETTINGS = {
  tone0ColorDarkHex: uppercaseHex(plecoDefaultToneColorsDark.tone0),
  tone0ColorDarkName: "gray",
  tone0ColorLightHex: uppercaseHex(plecoDefaultToneColorsLight.tone0),
  tone0ColorLightName: "gray",

  tone1ColorDarkHex: uppercaseHex(plecoDefaultToneColorsDark.tone1),
  tone1ColorDarkName: "red",
  tone1ColorLightHex: uppercaseHex(plecoDefaultToneColorsLight.tone1),
  tone1ColorLightName: "red",

  tone2ColorDarkHex: uppercaseHex(plecoDefaultToneColorsDark.tone2),
  tone2ColorDarkName: "green",
  tone2ColorLightHex: uppercaseHex(plecoDefaultToneColorsLight.tone2),
  tone2ColorLightName: "green",

  tone3ColorDarkHex: uppercaseHex(plecoDefaultToneColorsDark.tone3),
  tone3ColorDarkName: "blue",
  tone3ColorLightHex: uppercaseHex(plecoDefaultToneColorsLight.tone3),
  tone3ColorLightName: "blue",

  tone4ColorDarkHex: uppercaseHex(plecoDefaultToneColorsDark.tone4),
  tone4ColorDarkName: "purple",
  tone4ColorLightHex: uppercaseHex(plecoDefaultToneColorsLight.tone4),
  tone4ColorLightName: "purple",
} as const;
